function addNewRecommend() {
  return {
    storageKey: 'product_recommend__add_new',
    allowedUrl: null,
    errorTimeout: null,
    selectedProtocolId: null,
    selectedProducts: null,

    init() {
      this.$nextTick(() => {  
        const form = this.$el.querySelector('.add-recommendation__form');
        if (!form) return;

        const fields = form.querySelectorAll(
          'input[required], textarea[required]'
        );
        fields.forEach((field) => {
          field.addEventListener('input', () => {            
            if (field.value && field.value !== '') {
              field.parentElement.classList.remove('error');
            }
          });
        });
        this.loadFromStorage();
      });
      this.initProtocolSelect();
    },

    initProtocolSelect() {
      const titleInput = document.getElementById('recommendation-title');
      const detailsTextarea = document.getElementById('recommendation-details');
      const protocolItems = document.querySelectorAll('.add-recommendation__option-item');
      const scriptEl = document.getElementById('PROTOCOL_DATA');
      const recommendForm = document.querySelector('.add-recommendation__form');

      if (!scriptEl || !protocolItems.length) return;

      let protocols = [];
      try {
        protocols = JSON.parse(scriptEl.textContent);
      } catch (e) {
        console.error('Invalid PROTOCOL_DATA');
        return;
      }

      const parseRichTextToPlainText = (noteRaw = '') => {
        try {
          const json = JSON.parse(noteRaw);
          if (!Array.isArray(json.children)) return '';

          return json.children
            .map(block => {
              if (!Array.isArray(block.children)) return '';
              return block.children
                .filter(n => n.type === 'text')
                .map(n => n.value)
                .join('');
            })
            .filter(Boolean)
            .join('\n');
        } catch {
          return '';
        }
      };

      document.addEventListener('protocol:selected', (e) => {
        const { systemId } = e.detail || {};
        if (!systemId) return;

        const form = document.querySelector('.add-recommendation__form');

        if (!form) return;

        if (!form.classList.contains('protocols-enabled')) {
          this.selectedProducts = null;
          return;
        }
        const protocol = protocols.find(
          p => String(p.system_id) === String(systemId)
        );
        if (!protocol || !Array.isArray(protocol.products)) {
          this.selectedProducts = null;
          return;
        }
        this.selectedProducts = protocol.products;
      });
      protocolItems.forEach((item) => {
        item.addEventListener('click', () => {
          this.selectedProducts = null;

          const protocolId = item.dataset.systemId;
          if (!protocolId) return;

          const protocol = protocols.find(
            p => String(p.system_id) === String(protocolId)
          );
          if (!protocol) return;

          /* ===== Title ===== */
          if (titleInput) {
            titleInput.value = protocol.title || '';
            titleInput.dispatchEvent(new Event('input'));
          }

          /* ===== Details ===== */
          if (detailsTextarea) {
            detailsTextarea.value = parseRichTextToPlainText(protocol.note);
            detailsTextarea.dispatchEvent(new Event('input'));
          }
          recommendForm.classList.add('protocols-enabled');
        });
      });
    },

    loadFromStorage() {
      const raw = localStorage.getItem(this.storageKey);
      if (!raw) return;

      let data;
      try {
        data = JSON.parse(raw);
      } catch (e) {
        console.warn('Invalid recommend storage data');
        return;
      }

      if (!data?.body) return;

      const patientNameEl = document.querySelector('#recommendation-name');
      const titleEl = document.querySelector('#recommendation-title');
      const instructionsEl = document.querySelector('#recommendation-details');

      if (patientNameEl && data.body.patient_name) {
        patientNameEl.value = data.body.patient_name;
        patientNameEl.dispatchEvent(new Event('input'));
      }

      if (titleEl && data.body.title) {
        titleEl.value = data.body.title;
        titleEl.dispatchEvent(new Event('input'));
      }

      if (instructionsEl && data.body.note) {
        let text = '';

        if (typeof data.body.note === 'string') {
          const note = data.body.note.trim();

          if (note.startsWith('{') || note.startsWith('[')) {
            try {
              const json = JSON.parse(note);
              text =
                json?.children?.[0]?.children
                  ?.filter(n => n.type === 'text')
                  .map(n => n.value)
                  .join('\n') || '';
            } catch (e) {
              console.warn('Note is not valid JSON, fallback to plain text');
              text = note;
            }
          } else {
            text = note;
          }
        }
        instructionsEl.value = text;
        instructionsEl.dispatchEvent(new Event('input'));
      }
    },

    validateForm() {
      const form = this.$el.closest('.add-recommendation__form');
      if (!form) return true;

      const fields = form.querySelectorAll(
        'input[required], textarea[required]'
      );

      let isValid = true;

      fields.forEach((field) => {
        const hasValue = field.value && field.value.trim() !== '';

        if (!hasValue) {
          isValid = false;
          field.parentElement.classList.add('error');
        } else {
          field.parentElement.classList.remove('error');
        }
      });

      if (!isValid) {
        form.classList.add('error-submit');

        clearTimeout(this.errorTimeout);
        this.errorTimeout = setTimeout(() => {
          form.classList.remove('error-submit');
        }, 5000);
      }

      return isValid;
    },
    handleEditRecommendationProducts() {
      let storageData;

      try {
        storageData = JSON.parse(localStorage.getItem(this.storageKey));
      } catch {
        return;
      }
      if (
        !storageData?.body?.recommendation_add_new_id ||
        !storageData?.body?.recommendation_edit
      ) {
        return;
      }


      if (
        Array.isArray(this.selectedProducts) &&
        this.selectedProducts.length > 0
      ) {
        return;
      }

      const scriptEl = document.getElementById('RECOMMENDATIONS_DATA');
      if (!scriptEl) return;

      let recommendList = [];
      try {
        recommendList = JSON.parse(scriptEl.textContent);
      } catch {
        console.error('Invalid RECOMMENDATIONS_DATA');
        return;
      }

      const recommendId = String(storageData.body?.recommendation_add_new_id);
      const matchedRecommend = recommendList.find(
        r => String(r.system_id) === recommendId
      );

      if (!matchedRecommend || !Array.isArray(matchedRecommend.products)) return;

      storageData.body = {
        ...(storageData.body || {}),
        products: matchedRecommend.products
      };

      localStorage.setItem(this.storageKey, JSON.stringify(storageData));
    },

    handleAddSubmit(allowedUrl, customerId) {
      if (!this.validateForm()) return;

      const nameInput = document.querySelector('#recommendation-name');
      const titleEl = document.querySelector('#recommendation-title');
      const instructionsEl = document.querySelector('#recommendation-details');

      const newBody = {
        customer_id: customerId != null ? customerId : null,
        title: titleEl ? titleEl.value : '',
        note: instructionsEl ? instructionsEl.value : '',
        patient_name: nameInput ? nameInput.value : '',
        recommend_value: true
      };

      const form = document.querySelector('.add-recommendation__form');
      if (form && form.classList.contains('protocols-enabled') && Array.isArray(this.selectedProducts) && this.selectedProducts.length) {
        newBody.products = this.selectedProducts;
      }

      let existing;
      try {
        existing = JSON.parse(localStorage.getItem(this.storageKey)) || {};
      } catch {
        existing = {};
      }

      const payload = {
        ...existing,
        body: {
          ...(existing.body || {}),
          ...newBody
        }
      };

      localStorage.setItem(this.storageKey, JSON.stringify(payload));

      this.handleEditRecommendationProducts();

      this.allowedUrl = allowedUrl;
      window.location.href = allowedUrl;
    }
  }
}